import { render, staticRenderFns } from "./configurationModal.vue?vue&type=template&id=2f003dc4"
import script from "./configurationModal.vue?vue&type=script&lang=js"
export * from "./configurationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports